import { specificThemeRender } from '@/utils/specificThemeRender';
import { getThemeComponent } from '@/utils/themeImports';
import { useSSRSelector } from 'src/redux';

const Categories = () => {
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  return (
    <section className="categories-page">
      {specificThemeRender(storeInfo)?.components?.Header?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, layout);
      })}
      <div className="categories-main">
        {specificThemeRender(storeInfo)?.components?.CLP?.map((layout) => {
          return getThemeComponent(layout.sub_type, layout.name, {
            showSeeMoreBtn: false,
            ...layout,
          });
        })}
      </div>
      {specificThemeRender(storeInfo)?.components?.Footer?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, layout);
      })}
    </section>
  );
};

export default Categories;
